export default __webpack_public_path__ + "static/media/bu3.e85539bf.jpg";